<template>
  <div class="logsCardContainer">
    <!-- 卡片 -->
      <div class="routes-table" v-if="op_logs.length">
        <div class="in-routes-table">
          <div class="name-name">运输节点</div>
          <div class="steps">
            <div v-for="(step,i) in op_logs"
            :key="i" class="step"
            :class="{'plan-to': step.icon === 'orange', 'finish':step.icon === 'grey', 'done': step.icon === 'green'}">
              <div class="icon-container">
                <span class="px-step-icon el-icon-success px-icon-success"
                v-if="step.icon === 'green' || step.icon === 'grey'"
                style="color:#67C23A;font-size:12px"></span>
                <span v-else class="px-step-icon step-icon-orange"></span>
                <span class="px-step-icon-line"></span>
              </div>
              <div class="content-container">
                <div class="title">
                  <span class="operation">{{step.operation}}</span>
                  <span class="plan-address">{{step.distance || '-'}}</span>
                </div>
                <div class="description">
                  <span class="plan-arrive-time">{{step.time || '-'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import { fetchDrivingLogsCard } from '../api';

export default {
  props: {
    task_id: {
      // eslint-disable-next-line
      type: String | Number,
      default: '',
    },
    order_state: {
      type: Number,
      default: -1,
    },
    // op_logs: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      op_logs: [],
    };
  },
  methods: {
    async getOpLogs() {
      const res = await fetchDrivingLogsCard({ task_id: this.task_id });
      if (res.errno === 0 && res.result) {
        this.op_logs = res.result;
        console.log('this.op_logs', this.op_logs);
      }
    },
    showDetail(step) {
      this.$emit('nodeDetail', { show: true, node_index: step.node_index });
    },
    timeIcon(mark) {
      let iconClass = '';
      let iconColor = '';
      switch (mark) {
        case 'ontime':
          iconClass = 'el-icon-success';
          iconColor = '#67C23A';
          break;
        case 'timeout':
          iconClass = 'el-icon-error';
          iconColor = 'red';
          break;
        case 'expect_ontime':
          iconClass = 'el-icon-orange';
          iconColor = '#67C23A';
          break;
        case 'expect_timeout':
          iconClass = 'el-icon-warning';
          iconColor = '#E6A23C';
          break;
        case 'not_arrival':
          iconClass = 'el-icon-orange';
          iconColor = '#909399';
          break;
        default:
          iconClass = 'el-icon-success';
          iconColor = '#67C23A';
          break;
      }
      return {
        iconClass,
        iconColor,
      };
    },
    distanceIcon(mark) {
      let iconClass = '';
      let iconColor = '';
      switch (mark) {
        case 'accurate_position':
          iconClass = 'el-icon-success';
          iconColor = '#67C23A';
          break;
        case 'locorrect_position':
          iconClass = 'el-icon-error';
          iconColor = 'red';
          break;
        case 'not_arrival':
          iconClass = 'el-icon-orange';
          iconColor = '#909399';
          break;
        default:
          iconClass = 'el-icon-success';
          iconColor = '#67C23A';
          break;
      }
      return {
        iconClass,
        iconColor,
      };
    },
  },
  created() {
    this.getOpLogs();
  },
};
</script>

<style lang="less">
@orange: rgb(230, 162, 60);
.logsCardContainer {
  width: 100vw;
  display: flex;
  justify-content: center;
  max-height: 35vh;
  overflow: scroll;
  .routes-table {
    background-color: #fff;
    width: 92%;
    overflow: auto;
    padding: 15px;
    padding-left: 40px;
    .in-routes-table {
      .name-name {
        padding-bottom: 20px;
        width: 150px;
        font-size: 30px;
        font-weight: bold;
        color: #2B2B2B;
      }
    }
  }
  .step {
    display: flex;
    // padding-bottom: 15px;
    .icon-container {
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .px-step-icon {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: rgb(112, 112, 112);
        position: absolute;
        top: 0;
        left: -3px;
      }
      .px-icon-success {
        width: 0px;
        height: 0px;
        background-color: transparent;
        font-size: 12px;
        left: -4.8px;
      }
      .step-icon-grey {
        background-color: rgb(112, 112, 112);
      }
      .step-icon-orange{
        background-color: orange;
      }
      .px-step-icon-line {
        display: inline-block;
        width: 2px;
        height: 100%;
        background:rgba(228,228,239,1);
      }
    }
    .content-container {
      padding-bottom: 25px;
      margin-left: 10px;
      .description {
        margin-top: 10px;
        color: #2B2B2B;
      }
      .title {
        display: flex;
        align-items: top;
        .operation {
          white-space:nowrap;
          margin-right: 30px;
          font-size: 20px;
          font-weight: bold;
        }
        .plan-address {
          max-width: 80%;
          display: inline-block;
          table-layout: fixed;
          word-wrap: break-all;
          word-break: normal;
          overflow: hidden;
          color: #999;
        }
      }
    }
  }
  .plan-to {
    .plan-arrive-time {
      color: orange;
    }
  }
  .step:last-child>.icon-container>.px-step-icon-line {
    width: 0px;
  }
}
@media screen and (min-width: 700px) {
   .logsCardContainer {
     width: 600px;
     max-height: calc(100vh - 200px);
     overflow-y: scroll;
     .routes-table {
       min-height: calc(100vh - 800px);
       display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .name-name{
        margin-bottom: 30px;
      }
      .content-container {
        padding-bottom: 50px;
      }
     }
   }
 }
</style>
